import { useTranslation } from 'react-i18next';
import TermsEN from '../../Components/Terms/Terms_en';
import TermsFR from '../../Components/Terms/Terms_fr';

export default function Terms(){
    const { i18n } = useTranslation();

    return (
        <div>
           {
             i18n.language === "fr" ? <TermsEN/> : <TermsFR/>
           }
        </div>
    )
}